import { UserNode } from './../../model/user-node';
import { SiteBuilder } from './../../model/builder/site.builder';
import { Site } from './../../model/site';
import { TrainingService } from './../../service/training.service';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import {SessionService} from '../../service/SessionService';
import { EmitterService } from '../../service/EmitterService';

@Component({
  selector: 'app-training-tree',
  templateUrl: './training-tree.component.html',
  styleUrls: ['./training-tree.component.css']
})
export class TrainingTreeComponent implements OnInit {

  @Output() activateTrainingSessionNode = new EventEmitter<TrainingSessionNodeSelectedEventArgs>();
  nodes = [];
  sites: Site[] = [];
  options = {};
  private members = [];

  constructor(private trainingService: TrainingService,
              private eventEmit: EmitterService,
              private session: SessionService) {
  }

  /*
  onActivate(event) {
    const currentNode = event.node;
    const eventArgs = {
      agentName: null,
      sessionName: null,
      siteName: null,
      members: []
    };
    eventArgs.members = this.trainingService.getAllMembersFromNode(this.sites, currentNode.data.id);
    if (eventArgs.members.length > 0) {
      const parent = currentNode.parent;
      if (parent.data.name != null) {
        const parentOfParent = parent.parent;
        if (parentOfParent.data.name != null) {
          eventArgs.siteName = parentOfParent.data.name;
          eventArgs.sessionName = parent.data.name;
          eventArgs.agentName = currentNode.data.name;
        } else {
          eventArgs.siteName = parent.data.name;
          eventArgs.sessionName = currentNode.data.name;
        }
      } else {
        eventArgs.siteName = currentNode.data.name;
      }
      this.activateTrainingSessionNode.emit(eventArgs);
    }
  }
  */
  public onActivate() {
    return (members: any) => {
      const eventArgs = {
        start: null,
        end: null,
        agentName: null,
        teamName: null,
        siteName: null,
        members: []
      };
      members = members[0];
      eventArgs.start   = members.start;
      eventArgs.end   = (typeof members.end != 'undefined' ? members.end : null);
      eventArgs.members   = members.users;
      eventArgs.siteName  = members.siteName;
      eventArgs.teamName  = members.teamName;
      eventArgs.agentName = members.agentName;
      eventArgs.siteName  = (eventArgs.siteName === eventArgs.teamName ? '' : eventArgs.siteName);
      if (eventArgs.teamName !== null && eventArgs.siteName === '') {
        eventArgs.siteName = eventArgs.teamName;
        eventArgs.teamName = '';
      }
      this.eventEmit.emitChangeEvent(eventArgs);
    };
  }

  ngOnInit() {
    this.trainingService.loadHierarchy().subscribe((sitesVO: any) => {
      sitesVO.forEach(siteVO => {
        this.sites.push(SiteBuilder.build(siteVO, true));
      });
      this.nodes = this.trainingService.buildTree(this.sites);
    }, error1 => {
      this.session.redirectBadRequest(error1);
    });
  }

  filter(query: string) {
    this.nodes = this.trainingService.buildTree(this.sites, query);
  }
  public test() {
      return (members) => {
        // console.log(members);
      };
  }
}

export interface TrainingSessionNodeSelectedEventArgs {
  agentName: string;
  sessionName: string;
  siteName: string;
  members: UserNode[];
}



// WEBPACK FOOTER //
// ./src/app/view/training-tree/training-tree.component.ts